import {
    Component,
    Input,
    OnInit,
    OnChanges,
    HostListener,
    ElementRef,
} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfirmationDialogComponent} from '@dialogs/confirmation/confirmation.component';
import {
    IconDefinition,
    faBookmark as faBookmarkOutline,
    faBookOpen,
    faCloudUpload,
    faDownload,
    faGraduationCap,
    faPaperPlane,
    faSave,
    faTrash,
    faPollH,
    faEye,
    faEdit,
    faCircleInfo,
    faChevronDoubleLeft,
    faArrowLeftToLine,
    faArrowRightToLine,
    faPeopleGroup,
    faMessageLines,
    faPlus,
    faGear,
    faBell,
    faCircleQuestion,
    faHouse,
    faCopy,
} from '@fortawesome/pro-light-svg-icons';
import {faGrid} from '@fortawesome/pro-thin-svg-icons';

import {
    faArrowRightFromBracket,
} from '@fortawesome/pro-duotone-svg-icons';

import {
    faSortDown,
    faUpload,
    faEllipsis,
    faHouse as faHouseSolid,
} from '@fortawesome/pro-solid-svg-icons';
import {faHome} from '@fortawesome/pro-regular-svg-icons';
import {faBookmark, faChevronDown} from '@fortawesome/pro-solid-svg-icons';
import {AuthService} from '@services/auth.service';
import {CommonService} from '@services/common.service';
import {CanvasService} from '@services/canvas.service';

import {CreateDialogComponent} from '../dialogs/create/create.component';
import {WidgetDialogComponent} from '../dialogs/widget/widget.component';
import {environment} from '@environments/environment';
import {ROUTE_URL} from '../../constants/routes';

const NavigationIcons: {
    [key: string]: any;
} = {
    faArrowRightFromBracket,
    faUser: { // override with NC's version
        prefix: 'fa',
        iconName: 'user',
        icon: [
            226.1115723,
            226.0400391,
            [],
            '',
            `M193.0646362,33.1035156C171.7189331,11.7563477,143.3370972,0,113.14814,0
	C82.9596634,0,54.5778236,11.7568359,33.2316322,33.1035156C10.3205013,56.0136719-1.431452,85.96875,0.1393488,117.4501953
	c1.4155273,28.3574219,13.4770508,55.8710938,33.0922852,75.4863281
	c21.3466797,21.3466797,49.7280312,33.1030273,79.9169922,33.1035156c0.0019531,0,0,0,0.0014648,0
	c30.1874924,0,58.5707932-11.7573242,79.9150314-33.1035156C237.1271362,148.8691406,237.1271362,77.1679688,193.0646362,33.1035156
	z M113.953804,61.2460938c12.9130859,0,23.38134,10.4682617,23.38134,23.3813477
	c0,12.9135742-10.4682541,23.3813477-23.38134,23.3813477c-12.9135742,0-23.3813477-10.4677734-23.3813477-23.3813477
	C90.5724564,71.7143555,101.0402298,61.2460938,113.953804,61.2460938z M113.1486282,208.7783203
	c-15.3886719,0-30.2211914-3.6108398-43.5371094-10.4223633c0.1855469-2.2783203,0.3217773-3.9418945,0.3344727-4.0703125
	c4.0639648-41.3955078,22.222168-72.6137695,44.0078125-72.6137695c21.7226486,0,39.8388596,31.0380859,43.9721603,72.2558594
	c0.015625,0.1582031,0.1679688,1.6015625,0.3769531,3.5869141
	C144.5768433,204.8735352,129.163269,208.7788086,113.1486282,208.7783203z`
        ],
    },
};

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit, OnChanges {
    @Input() canvasMode: any;
    @Input() canvasLayout: any = false;
    @Input() hasEdit?: any;
    @Input() loggedIn: any;
    @Input() canvasId: any;
    @Input() isFavorite?: any;

    @Input() canvasType?: any;

    @Input() title?: any;
    @Input() description?: any;
    @Input() isDirty?: any;

    @Input() status?: any;
    @Input() editable?: any;

    @Input() fixedHeader = false;
    @Input() canvasAccess = true;
    @Input() disableEdit = false;
    private listener: any;

    constructor(
        private _snackBar: MatSnackBar,
        public dialog: MatDialog,
        private authService: AuthService,
        private canvasService: CanvasService,
        public commonService: CommonService,
        private eRef: ElementRef
    ) {
        this.listener = this.authService.listen().subscribe(() => {
            this.populateUserName();
        });
    }

    public user_name = '';
    public ROUTE_URL = ROUTE_URL;
    public navigation: any;
    public helpLinks: any;
    public adminAccess = false;

    public enablePublishing = environment.disableUI.enablePublishing || false;
    public enableCMS = environment.disableUI.enableCMS || false;

    faChevronDown = faChevronDown;
    faBookOpen = faBookOpen;
    faGraduationCap = faGraduationCap;
    faBookmarkOutline = faBookmarkOutline;
    faBookmark = faBookmark;
    faCloudUpload = faCloudUpload;
    faUpload = faUpload;
    faPaperPlane = faPaperPlane;
    faDownload = faDownload;
    faSave = faSave;
    faHome = faHome;
    faTrash = faTrash;
    faPollH = faPollH;
    faEye = faEye;
    faEdit = faEdit;
    faHouse = faHouse;
    faCopy = faCopy;
    faCircleInfo = faCircleInfo;
    faChevronDoubleLeft = faChevronDoubleLeft;
    faArrowLeftToLine = faArrowLeftToLine;
    faArrowRightToLine = faArrowRightToLine;
    faPeopleGroup = faPeopleGroup;
    faMessageLines = faMessageLines;
    faGrid = faGrid;
    faSortDown = faSortDown;
    faGear = faGear;
    faBell = faBell;
    faCircleQuestion = faCircleQuestion;
    faPlus = faPlus;
    faEllipsis = faEllipsis;
    faHouseSolid = faHouseSolid;
    public showApplications = false;
    public enterpriseDashboardId: any = 0;

    @HostListener('document:click', ['$event'])
    clickout(event: any) {
        if (this.eRef.nativeElement.contains(event.target)) {
            if (event.target.classList.length == 1) { this.showApplications = false; }
        } else {
            this.showApplications = false;
        }
    }

    getNavigationIcon(type: string): IconDefinition {
        return NavigationIcons[type];
    }

    toggleApplicationList() {
        if (this.showApplications) {
            this.showApplications = false;
        } else {
            this.showApplications = true;
        }
    }

    closeApplicationList(event: any) {
        this.showApplications = false;
    }

    getInitials(name: string) {
        const returnVal: string = this.commonService.getInitials(name);
        return returnVal;
    }

    openCreateDialog(): void {
        const dialogRef = this.dialog.open(CreateDialogComponent, {
            width: '350px',
            disableClose: true,
            data: {
                canvasType: this.canvasType,
            },
            panelClass: 'canvas-dialog',
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
            }
        });
    }

    openWidgetDialog(): void {
        const dialogRef = this.dialog.open(WidgetDialogComponent, {
            width: '350px',
            disableClose: true,
            data: {
                canvasType: this.canvasType,
            },
            panelClass: 'canvas-dialog',
        });

        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
            }
        });
    }

    logoutUser() {
        this.authService.logout();
        const platformUrl = sessionStorage.getItem('platformUrl');
        const url = platformUrl + '/index.php?module=td_logout&mode=logout';
        window.location.href = url;
    }

    getShortName(name: string) {
        name = name.trim();

        let returnVal = '';
        const nameArray = name && name.split(' ');
        if (nameArray && nameArray.length > 1) {
            returnVal = nameArray[0];
        } else {
            if (nameArray) {
                let str = nameArray[0];
                str = str[0].toUpperCase() + str.slice(1);
                returnVal = str;
            }
        }
        return returnVal;
    }

    saveCanvas(obj: string) {
        this.canvasService.triggerSave();
    }

    //  other below functions need to be fleshed out
    gotoDashboard() {
        this.canvasService.triggerExportToDashboard();
    }

    editAsReport(obj: string) {
        this.highlightToolIcon(obj);
        this.canvasService.triggerEditAsReport();
    }

    editAsLayout(obj: string) {
        this.highlightToolIcon(obj);
        this.canvasService.triggerEditAsLayout();
    }

    viewCanvas(obj: string) {
        this.highlightToolIcon(obj);
        this.canvasService.triggerView();
    }

    editCanvas(obj: string) {
        this.canvasService.triggerEdit();
    }

    reportDetails(obj: string) {
        this.canvasService.triggerDetail();
    }

    reportGroups(vieMode: boolean) {
        if (vieMode) { this.canvasService.triggerViewGroups(); }
        else { this.canvasService.triggerGroups(); }
    }

    exportReport(obj: string) {
        this.canvasService.triggerExport();
    }

    publishReports(obj: string) {
        this.canvasService.triggerPublish();
    }

    productFeedback(obj: string, event: any, canvasType: any) {
        this.commonService.openRoadmapLinkDialog(event, canvasType);
    }

    publishCanvas(obj: string) {
        this.canvasService.triggerPublish();
    }

    deleteCanvas(obj: string) {
        this.canvasService.triggerDelete();
    }

    duplicateCanvas() {
        this.canvasService.triggerDuplicate();
    }

    shareReport(obj: string) {
        this._openSnackBar('Report shared', true);
    }

    makeDefaultDashboard(id: number, obj: string, setDefault: boolean) {
        const userObject = JSON.parse(sessionStorage.getItem('userObject'));
        const savedId = parseInt(userObject.enterpriseDashboardId.toString());
        const currentId = parseInt(id.toString());

        if (setDefault) {
            switch (savedId) {
                case 0:
                    this.saveDefaultDashboard(currentId, userObject);

                    break;
                case currentId:
                    break;
                default:
                    this.canvasService
                    .getCanvasLight(savedId.toString())
                    .subscribe((data: any) => {
                        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                            disableClose: true,
                            width: '500px',
                            data: {
                                message:
                                    '<strong>' +
                                    data.data.name +
                                    '</strong> is your current home dashboard.',
                                messageDetail: 'Would you like to update it?',
                                actionButton: 'Update',
                            },
                            panelClass: 'canvas-dialog',
                        });

                        dialogRef.afterClosed().subscribe((result) => {
                            if (result) {
                                this.saveDefaultDashboard(currentId, userObject);
                            }
                        });
                    });

                    break;
            }
        } else {
            this.saveDefaultDashboard(null, userObject);
        }
    }

    saveDefaultDashboard(id: any, userObject: any) {
        const body = {
            enterpriseDashboardId: id,
        };
        this.canvasService.saveDefaultDashboard(body).subscribe(
            (success: any) => {
                if (!id) { id = userObject.savedEnterpriseDashboardId; }
                userObject.enterpriseDashboardId = id;
                this.enterpriseDashboardId = id;
                const savedEnterpriseDashboardId =
                    userObject.savedEnterpriseDashboardId;
                userObject = JSON.stringify(userObject);
                sessionStorage.setItem('userObject', userObject);

                let _set = true;
                if (id == 0) { _set = false; }
                if (id == savedEnterpriseDashboardId) { _set = false; }

                if (!_set) {
                    this.authService.fetchUser().then(r => {
                        this._openSnackBar('Dashboard removed as home', true);
                    });
                } else {
                    this._openSnackBar('Dashboard set as home', true);
                }
            },
            (error: any) => {
                this._openSnackBar(
                    'There was a problem setting the default dashboard',
                    false
                );
            }
        );
    }

    favoriteCanvas(id: number, obj: string) {
        this.isFavorite = !this.isFavorite;
        this.canvasService.favoriteCanvas(id);
        //  need to refresh favorite from canvas object
        if (this.isFavorite) {
            this._openSnackBar('Favorite Added', true);
        } else {
            this._openSnackBar('Favorite Removed', true);
        }
    }

    highlightToolIcon(obj: string) {
        const icon = document.querySelector('#' + obj);
        icon!.classList.add('activeTool');

        setTimeout(() => icon!.classList.remove('activeTool'), 3000);
    }

    highlightIcon(obj: string) {
        const icon = document.querySelector('#' + obj);
        icon!.classList.add('active');
        setTimeout(() => icon!.classList.remove('active'), 3000);
    }

    _openSnackBar(message: string, success: boolean) {
        let successClass = 'canvas-snackbar';
        if (!success) {
            successClass = 'canvas-snackbar-error';
        }
        this._snackBar.open(message, '', {
            duration: 3000,
            panelClass: [successClass],
        });
    }

    populateUserName() {
        const userObject = JSON.parse(sessionStorage.getItem('userObject'));

        if (userObject) {
            this.enterpriseDashboardId = userObject.enterpriseDashboardId;

            this.user_name = userObject.name || 'User';
            if (this.user_name.includes(',')) {
                const temp = this.user_name.split(' ');
                this.user_name = temp[1] + ' ' + temp[0].slice(0, -1);
            }

            const temp = this.user_name.split(' ');
            let tempStr = '';
            temp.forEach((val: any) => {
                tempStr += val.charAt(0).toUpperCase() + val.slice(1) + ' ';
            });
            this.user_name = tempStr;

            // adding a check for adim access.... is based on the user group
            const userGroupId = userObject.userGroupId;
            if (userGroupId == 0) { this.adminAccess = true; }
        }
    }

    getNavigation() {
        setTimeout(() => {
            const userObject = JSON.parse(sessionStorage.getItem('userObject'));
            if (userObject) {
                const profileMenu = userObject.profileMenus.data;
                if (profileMenu) {
                    this.navigation = profileMenu;
                    this.helpLinks = profileMenu.filter((item: any) => {
                        return item.title == 'Help';
                    });
                }
            } else {
                this.getNavigation();
            }
        }, 100);
    }

    ngOnChanges(): void {
        this.populateUserName();
    }

    ngOnInit(): void {
        this.getNavigation();
        this.populateUserName();
    }
}
